// export default () => ({
// })

export default () => ({
    municipalities: [],
    municipalitiesSelectable: [],
    municipalitiesPaginatedData: null,
    municipality: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})